import { DataLayer } from "libs/providers/datalayer/datalayer";
import { getAutoefectivoName } from '../utils/datalayer';

export const useHeader = () => {

    const handleSelectQuotation = (pathname: string) => {

        const name = getAutoefectivoName(pathname);
        window.scrollTo({
            top: 100,
            behavior: 'smooth',
        })

        DataLayer.setVirtualEvent({
            tipoZona: 'Autos',
            zona: `PlanAutoefectivo${name}Leads`,
            subZona: 'Inicio',
            sección: 'Top',
            tipoEvento: 'click',
            tipoElemento: 'Botón',
            valor: `Solicítalo aquí - top`
        });
    }

    return { handleSelectQuotation }
}